import styled from 'styled-components'

const InputContainer = styled.div`
  position: relative;
`

export default InputContainer
